<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-md-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
        <transition v-if="banner" enter-active-class="fadeIn" leave-active-class="fadeOut">
          <div class="alert alert-danger alert-dismissible fade show">
            <button type="button" aria-hidden="true" data-dismiss="alert" aria-label="Close" class="close">
              <i class="nc-icon nc-simple-remove"></i>
            </button>
            <span>
				<strong> Warning - </strong> <span v-html="bannerMessage"></span>
			</span>
          </div>
        </transition>
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
				</div>
				<div class="edit-profile" v-else>
					<!-- Name Update Section - Start -->
					<div class="card" v-if="asyncDone === true">
						<div class="card-header">
							<h4 class="card-title">Update Your Name</h4>
						</div>
						<div class="card-body">
							<form class="form-horizontal" @submit.prevent="updateAdminName">
								<div class="row">
									<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">First Name</label>
									<div class="col-sm-4 col-md-4 col-lg-4">
										<div class="form-group">
											<input type="text" class="form-control" v-model.trim="adminUser.firstName">
										</div>
									</div>
									<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Last Name</label>
									<div class="col-sm-4 col-md-4 col-lg-4">
										<div class="form-group">
											<input type="text" class="form-control" v-model.trim="adminUser.lastName">
										</div>
									</div>
								</div>
								<!-- Section to show customer's account details END -->
								<div class="row">
									<label class="col-sm-2 col-form-label"></label>
									<div class="col-sm-10">
										<div class="form-group">
											<button type="submit" class="btn btn-warning">Update Your Name</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Update Your HostBill Full Name</h4>
            </div>
            <div class="card-body">
              <form class="form-horizontal" @submit.prevent="updateAdminHostBillUserName">
                <div class="row">
                  <label class="col-sm-3 col-md-3 col-lg-3 col-form-label">HostBill Full Name</label>
                  <div class="col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <input type="text" class="form-control" v-model.trim="adminUser.hbName">
                    </div>
                  </div>
                </div>
                <!-- Section to show customer's account details END -->
                <div class="row">
                  <label class="col-sm-3 col-form-label"></label>
                  <div class="col-sm-9">
                    <div class="form-group">
                      <button type="submit" class="btn btn-warning">Update Your HostBill Full Name</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Update Toast Notifications Settings</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <label class="col-sm-3 col-md-3 col-lg-3 col-form-label">Turn ON Notifications</label>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : getNotificationStatus, 'bootstrap-switch-off bootstrap-switch-focused' : !getNotificationStatus }">
                    <div class="bootstrap-switch-container" @click="updateIsNotificationsForUser()">
                      <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                      <span class="bootstrap-switch-label"></span>
                      <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="card">
						<div class="card-header">
							<h4 class="card-title">Update Your Signature</h4>
						</div>
						<div class="card-body">
							<form class="form-horizontal" @submit.prevent="updateAdminSignature">
								<div class="row">
									<label class="col-sm-3 col-md-3 col-lg-3 col-form-label">Signature</label>
									<div class="col-sm-6 col-md-6 col-lg-6">
										<div class="form-group">
                      <textarea class="form-control" required rows="4" v-model="adminUser.signature"></textarea>
										</div>
									</div>
								</div>
								<!-- Section to show customer's account details END -->
								<div class="row">
									<label class="col-sm-3 col-form-label"></label>
									<div class="col-sm-9">
										<div class="form-group">
											<button type="submit" class="btn btn-warning">Update Your Signature</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
					<!-- Name Update Section - End -->
					<div class="row">
						<div class="col-12 col-sm-6">
							<!-- Email Update Section - Start -->
							<div class="card">
								<div class="card-header ">
									<h4 class="card-title">Update Your Email</h4>
								</div>
								<div class="card-body ">
									<form class="form-horizontal" @submit.prevent="updateAdminEmail">
										<div class="row">
											<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Email ID</label>
											<div class="col-sm-8 col-md-8 col-lg-8">
												<div class="form-group">
													<input type="email" class="form-control" v-model.trim="adminUser.email">
												</div>
											</div>
										</div>
										<!-- Section to show customer's account details END -->
										<div class="row">
											<label class="col-sm-2 col-form-label"></label>
											<div class="col-sm-10">
												<div class="form-group">
													<button type="submit" class="btn btn-warning" :disabled="!adminUser.email">Update Your Email ID</button>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
							<!-- Email Update Section - End -->
						</div>
						<div class="col-12 col-sm-6">
							<!-- Password Update Section - Start -->
							<div class="card">
								<div class="card-header ">
									<h4 class="card-title">Update Your Password</h4>
								</div>
								<div class="card-body ">
									<form class="form-horizontal" @submit.prevent="updateAdminPassword">
										<div class="row">
											<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Password</label>
											<div class="col-sm-8 col-md-8 col-lg-8">
												<div class="form-group">
													<input type="password" placeholder="Must be atleast 6 charecters" class="form-control" v-model.trim="adminUser.password">
												</div>
											</div>
										</div>
										<!-- Section to show customer's account details END -->
										<div class="row">
											<label class="col-sm-2 col-form-label"></label>
											<div class="col-sm-10">
												<div class="form-group">
													<button type="submit" class="btn btn-warning" :disabled="!adminUser.password">Update Your Password</button>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
							<!-- Password Update Section - End -->
						</div>
					</div>

					<!-- 2FA Section... -->
					<div class="card">
						<div class="card-body">
							<TwoFAUpdate @toggleBanner="toggleBanner" />
						</div>
					</div>

          <passkeys />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { db, auth } from "@/firebase/init";
import Passkeys from "@/components/Helps/Passkeys";

import swal from "sweetalert2";

export default {
  name: "editAdminProfile",
  components: {
    Passkeys,
    Alert: () =>
      import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
	  TwoFAUpdate: () =>
		  import(/* webpackChunkName: "passwordDetailsSection" */ "../../../components/User/EditProfile/TwoFAUpdate.vue"),
  },
  data() {
    return {
      adminUser: this.$store.getters.user,
      banner: false,
      bannerMessage: 'Please enable 2FA for your account.'
    };
  },
  computed: {
    fullName() {
      return this.$store.getters.userFullName;
    },
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
    },
    user() {
      return this.$store.getters.user;
    },
    getNotificationStatus(){
      return this.user.getNotificationStatus
    }

  },
  methods: {
    async  updateIsNotificationsForUser(){
      try{
        const flag = this.getNotificationStatus ? false : true;
        await db.collection('users').doc(this.user.uid).update({
          getNotificationStatus : flag
        })
        await this.$store.dispatch('setPushNotificationStatus', flag);
      }
      catch(e){
        console.log(e.toString())
      }
    },
    toggleBanner () {
      this.banner = !this.banner
      if(this.banner){
        swal('2FA required!', 'Please Enable 2FA for you Account', 'info');
      }
    },
    async updateAdminHostBillUserName(){
     await this.$store.dispatch("async/stateUpdate", { state: false });
     try{
       await db.collection('users').doc(this.adminUser.uid).update({
         hbName:this.adminUser.hbName,
       });
       localStorage.setItem('userDtls', JSON.stringify(this.adminUser))
       await this.$store.dispatch("updateHbName", {
         hbName: this.adminUser.hbName,
       });
       await this.$store.dispatch("async/stateUpdate", { state: true });

       await this.$store.dispatch("alert/update", {
         type: "success",
         message: "Your hostBill UserName has successfully been updated",
         show: true
       });

       setTimeout(() => {
         this.$store.dispatch("alert/showUpdate", { show: false });
       }, 5000);
     }
     catch(err){
       await this.$store.dispatch("async/stateUpdate", { state: true });

       // Show success message to the user for 5 sec
      await  this.$store.dispatch("alert/update", {
         type: "danger",
         message: err,
         show: true
       });

     await  setTimeout(() => {
         this.$store.dispatch("alert/showUpdate", { show: false });
       }, 5000);
     }

    },
    async updateAdminSignature () {
      this.$store.dispatch("async/stateUpdate", { state: false });

      // Now connect with the firestore database to update the details there
      db
          .collection("users")
          .doc(this.adminUser.uid)
          .update({
            signature: this.adminUser.signature
          })
          .then(() => {

            localStorage.setItem('userDtls', JSON.stringify(this.adminUser))
            // Send the updated data to Vuex
            this.$store.dispatch("updateSignature", {
              signature: this.adminUser.signature,
            });

            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", { state: true });

            // Show success message to the user for 5 sec
            this.$store.dispatch("alert/update", {
              type: "success",
              message: "Your signature has successfully been updated",
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", { show: false });
            }, 5000);
          })
          .catch(err => {
            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", { state: true });

            // Show success message to the user for 5 sec
            this.$store.dispatch("alert/update", {
              type: "danger",
              message: err,
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", { show: false });
            }, 5000);
          });
    },
    updateAdminName() {
      if (this.adminUser.firstName) {
        // Set asyncDone to false
        this.$store.dispatch("async/stateUpdate", { state: false });

        // Now connect with the firestore database to update the details there
        db
          .collection("users")
          .doc(this.adminUser.uid)
          .update({
            firstName: this.adminUser.firstName,
            lastName: this.adminUser.lastName || ''
          })
          .then(() => {
            // Send the updated data to Vuex
            this.$store.dispatch("updateName", {
              firstName: this.adminUser.firstName,
              lastName: this.adminUser.lastName || ''
            });
            const usrDetails = JSON.parse(localStorage.getItem('userDtls'))
            usrDetails.firstName = this.adminUser.firstName
            usrDetails.lastName = this.adminUser.lastName || ''
            localStorage.setItem('userDtls', JSON.stringify(usrDetails))

            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", { state: true });

            // Show success message to the user for 5 sec
            this.$store.dispatch("alert/update", {
              type: "success",
              message: "Your name has successfully been updated",
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", { show: false });
            }, 5000);
          })
          .catch(err => {
            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", { state: true });

            // Show success message to the user for 5 sec
            this.$store.dispatch("alert/update", {
              type: "danger",
              message: err,
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", { show: false });
            }, 5000);
          });
      } else {
        this.$store.dispatch("alert/update", {
          type: "danger",
          message:
            "Please enter First Name and Last Name properly in order to update it.",
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false });
        }, 5000);
      }
    },
    updateAdminEmail() {
      if (this.adminUser.email) {
        // Check if the provided email id is actually an email or not
        const emailCheckRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailCheckRegex.test(this.adminUser.email)) {
          // Set asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false });

          // Now connect with the firebase auth server to update the email id
          auth.currentUser
            .updateEmail(this.adminUser.email)
            .then(() => {
              // Now update the email id to the firestore database for the user
              db
                .collection("users")
                .doc(this.adminUser.uid)
                .update({
                  email: this.adminUser.email
                })
                .then(() => {
                  // Now push the updated email id to the Vuex
                  this.$store.dispatch("updateEmail", {
                    email: this.adminUser.email
                  });

                  // Set asyncDone to true
                  this.$store.dispatch("async/stateUpdate", { state: true });

                  // Show success message to the user for 5 sec
                  this.$store.dispatch("alert/update", {
                    type: "success",
                    message: "Your email id has successfully been updated",
                    show: true
                  });

                  setTimeout(() => {
                    this.$store.dispatch("alert/showUpdate", { show: false });
                  }, 5000);
                })
                .catch(err => {
                  // Set asyncDone to true
                  this.$store.dispatch("async/stateUpdate", { state: true });

                  // Show success message to the user for 5 sec
                  this.$store.dispatch("alert/update", {
                    type: "danger",
                    message: err.message,
                    show: true
                  });

                  setTimeout(() => {
                    this.$store.dispatch("alert/showUpdate", { show: false });
                  }, 5000);
                });
            })
            .catch(err => {
              // Set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              // Show success message to the user for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err.message,
                show: true
              });

              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false });
              }, 5000);
            });
        } else {
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: "Entered email address is not a valid email address.",
            show: true
          });

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", { show: false });
          }, 5000);
        }
      } else {
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: "Please enter a valid email id in order to update it.",
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false });
        }, 5000);
      }
    },
    updateAdminPassword() {
      if (this.adminUser.password) {
        //Check if the entered password is atleast 6 charecters long
        if (this.adminUser.password.length > 5) {
          // Set the asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false });

          // Connect with firebase auth server to update the password
          auth.currentUser
            .updatePassword(this.adminUser.password)
            .then(() => {
							this.adminUser.password = null

              // Set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              // Show success message to the user for 5 sec
              this.$store.dispatch("alert/update", {
                type: "success",
                message: "Your password has successfully been updated",
                show: true
              });

              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false });
              }, 5000);
            })
            .catch(err => {
							this.adminUser.password = null

              // Set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err,
                show: true
              });

              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false });
              }, 5000);
            });
        } else {
					this.adminUser.password = null

          this.$store.dispatch("alert/update", {
            type: "danger",
            message: "Password must needs to be atleast 6 charecters long.",
            show: true
          });

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", { show: false });
          }, 5000);
        }
      } else {
        this.$store.dispatch("alert/update", {
          type: "danger",
          message:
            "Please enter a minimum 6 charecter password bbefore updating your password.",
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false });
        }, 5000);
      }
    },
  }
};
</script>
